import Usuarios from './services/Usuarios'

export default {
    Usuarios
}